import { createCustomEvent } from "../../shared/helpers";

export default class extends Controller {
  static targets = ["toggleLink"];

  toggleCompleted(event) {
    event.preventDefault();
    this.showComplete = !this.showComplete;
    this.toggleLinkTarget.innerText = `${this.showComplete ? "Hide" : "Show"} Completed`;
    document.dispatchEvent(createCustomEvent(this.eventName, this.element, this.eventDetail));
  }

  //
  // GETTERS AND SETTERS
  //

  get showComplete() {
    return [true, "true", 1, "1"].includes(this.data.get("show-complete"));
  }

  set showComplete(val) {
    this.data.set("show-complete", val ? "1" : "0")
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/milestones/milestones-toggle-complete-controller.js